import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestMfbDetails extends WorkrequestDetailsBase {

  spaRefNumber: string;
  vbaConsentNumber: string;
  preferredDateForVisit: string;
  mainMeterSize: string;
  errorMessage: string;

  constructor() {
    super();
    this.spaRefNumber = '';
    this.vbaConsentNumber = '';
    this.preferredDateForVisit = '';
    this.mainMeterSize = '';
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/mfb-form/workrequest-mfb-details.ts